import { Box, Stack } from "@mui/material";
import { useMemo } from "react";
import { useCardTransactions } from "Api/Queries/CardTransactions/useCardTransactions";
import { useCardTransactionsSum } from "Api/Queries/CardTransactions/useCardTransactionsSum";
import { CardTransactionFilterBar } from "Components/CardTransactions/CardTransactionFilterBar";
import { CardTransactionsList } from "Components/CardTransactions/CardTransactionsList";
import { CardTransactionsSummaryBox } from "Components/CardTransactions/CardTransactionsSummaryBox";
import { useCardTransactionFilterManager } from "Components/CardTransactions/hooks/useCardTransactionFilterManager";
import { ExportCardTransactionsActions } from "Components/Shared/ExportCardTransactionsActions";

type Props = {
  initialLimit?: number;
};

export const CardTransactionsTabContent = ({ initialLimit = 10 }: Props) => {
  const filterManager = useCardTransactionFilterManager();
  const { filters } = filterManager;
  const { data: sumData, isLoading: isLoadingSum } = useCardTransactionsSum({
    filters,
  });

  const { data, hasNextPage, fetchNextPage, isFetchingNextPage, isLoading } =
    useCardTransactions({ filters, limit: initialLimit });

  const transactions = useMemo(
    () => data?.pages?.flatMap(({ items }) => items) ?? [],
    [data],
  );

  const totalCount = data?.pages?.[0]?.totalCount ?? 0;

  return (
    <Stack gap={3}>
      <CardTransactionsSummaryBox sum={sumData} isLoading={isLoadingSum} />
      <Box display="flex" alignItems="center" gap={1}>
        <Box flexGrow={1}>
          <CardTransactionFilterBar filterManager={filterManager} />
        </Box>
        <ExportCardTransactionsActions filters={filters} />
      </Box>
      <CardTransactionsList
        transactions={transactions}
        totalCount={totalCount}
        hasNextPage={hasNextPage}
        fetchNextPage={fetchNextPage}
        isFetchingNextPage={isFetchingNextPage}
        isLoadingTransactions={isLoading}
        initialLimit={initialLimit}
      />
    </Stack>
  );
};
